import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { ConvenioModule } from '../app/apps/convenio/convenio.module';
import { environment } from '../environments/environment';

if (environment.production) {
    enableProdMode();
}

document.title = 'Convênio';

window.addEventListener('dragover', event => event.preventDefault(), false);
window.addEventListener('drop', event => event.preventDefault(), false);

platformBrowserDynamic().bootstrapModule(ConvenioModule);
